import { transport, BASE_PATH } from "@/src/config/apiConfig.js";
import { marketingTransport } from "@/src/config/marketingTransport.js";
import WorkspaceService from "@/src/api/WorkspaceService.js";

export default {
  setEmailAccountSharing: async (accountId, isShared) => {
    try {
      return await transport.put(
        BASE_PATH + `/api/mailboxes/${accountId}/sharing`,
        {
          is_team: isShared,
        },
      );
    } catch (error) {
      console.error("Error setting email account sharing:", error);
      throw error;
    }
  },
  getSmtpDetails: async (accountId) => {
    try {
      return await transport.get(
        BASE_PATH + `/api/mailboxes/${accountId}/smtp`,
      );
    } catch (error) {
      console.error("Error getting SMTP details:", error);
      throw error;
    }
  },
  updateSmtpDetails: async (accountId, details) => {
    try {
      const response = await transport.post(
        BASE_PATH + `/api/mailboxes/${accountId}/smtp`,
        details,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating SMTP details:", error);
      throw error;
    }
  },

  /* --------------- Salesforce Mappings --------------- */

  async fetchSalesforceFieldMappings(type) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/salesforce/fetch_field_mappings?entity_type=${type}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Salesforce field mappings:", error);
      throw error;
    }
  },

  async fetchSalesforceStatusMapping(type) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/salesforce/fetch_status_mappings?entity_type=${type}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Salesforce status mapping:", error);
      throw error;
    }
  },

  async fetchSalesforceContactsConfig() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/salesforce/fetch_contacts_config`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Salesforce contacts config:", error);
      throw error;
    }
  },

  async fetchSalesforceLeadsConfig() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/salesforce/fetch_leads_config`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Salesforce leads config:", error);
      throw error;
    }
  },

  async fetchSalesforceCompaniesConfig() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/salesforce/fetch_companies_config`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Salesforce companies config:", error);
      throw error;
    }
  },

  async fetchSalesforceDealsConfig() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/salesforce/fetch_deals_config`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Salesforce deals config:", error);
      throw error;
    }
  },

  async fetchSalesforceActivitiesConfig() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/salesforce/activities_config`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Salesforce activities config:", error);
      throw error;
    }
  },

  async fetchSalesforceSyncEnabled() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/salesforce/sync_enabled`);
      return res.data;
    } catch (error) {
      console.error("Error fetching Salesforce sync enabled status:", error);
      throw error;
    }
  },

  async fetchHubspotActivitiesConfig() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/activities_config`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot activities config:", error);
      throw error;
    }
  },

  async saveSalesforceActivitiesConfig(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/save_activities_config`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Salesforce activities config:", error);
      throw error;
    }
  },

  async saveSalesforceFieldMappings(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/save_field_mappings`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Salesforce field mappings:", error);
      throw error;
    }
  },

  async saveSalesforceStatusMapping(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/save_status_mappings`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Salesforce status mapping:", error);
      throw error;
    }
  },

  async saveSalesforceContactsConfig(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/save_contacts_config`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Salesforce contacts config:", error);
      throw error;
    }
  },

  async saveSalesforceLeadsConfig(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/save_leads_config`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Salesforce leads config:", error);
      throw error;
    }
  },

  async saveSalesforceCompaniesConfig(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/save_companies_config`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Salesforce companies config:", error);
      throw error;
    }
  },

  async saveSalesforceDealsConfig(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/save_deals_config`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Salesforce deals config:", error);
      throw error;
    }
  },

  async saveSalesforceSyncEnabled(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/sync_enabled`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Salesforce sync enabled status:", error);
      throw error;
    }
  },

  async pullContacts() {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/pull_contacts`,
        {},
      );
      return res.data;
    } catch (error) {
      console.error("Error pulling contacts:", error);
      throw error;
    }
  },

  async pullLeads() {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/pull_leads`,
        {},
      );
      return res.data;
    } catch (error) {
      console.error("Error pulling leads:", error);
      throw error;
    }
  },

  async pullEntity(entityType) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/salesforce/pull_entity/${entityType}`,
        {},
      );
      return res.data;
    } catch (error) {
      console.error("Error pulling salesforce entity: ", error);
      throw error;
    }
  },

  async disconnectSalesforce() {
    try {
      let res = await transport.post(
        BASE_PATH + "/api/salesforce/disconnect",
        {},
      );
      return res.data;
    } catch (error) {
      console.error("Error disconnecting Salesforce:", error);
      throw error;
    }
  },

  /* --------------- Hubspot Mappings --------------- */

  async fetchHubspotContactsConfig() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/fetch_contacts_config`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot contacts config:", error);
      throw error;
    }
  },

  async fetchHubspotStatusMapping(type) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/fetch_status_mappings`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot status mapping:", error);
      throw error;
    }
  },

  async saveHubspotContactsConfig(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/hubspot/save_contacts_config`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Hubspot contacts config:", error);
      throw error;
    }
  },

  async saveHubspotActivitiesConfig(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/hubspot/save_activities_config`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Hubspot activities config:", error);
      throw error;
    }
  },

  async fetchHubspotFieldMappings(type) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/fetch_field_mappings?entity_type=${type}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot field mappings:", error);
      throw error;
    }
  },

  async saveHubspotFieldMappings(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/hubspot/save_field_mappings`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Hubspot field mappings:", error);
      throw error;
    }
  },

  async disconnectHubspot() {
    try {
      let res = await transport.post(BASE_PATH + "/api/hubspot/disconnect", {});
      return res.data;
    } catch (error) {
      console.error("Error disconnecting Hubspot:", error);
      throw error;
    }
  },

  async fetchHubspotContactLists() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/fetch_contact_lists`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot contact lists:", error);
      throw error;
    }
  },

  async fetchZoomIntegration() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/zoom/integration`);
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoom integration:", error);
      throw error;
    }
  },

  async sendDataToZoomIntegration(payload) {
    try {
      let res = await transport.put(
        `${BASE_PATH}/api/zoom/integration`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error sending data to Zoom integration:", error);
      throw error;
    }
  },

  async disconnectZoom() {
    try {
      let res = await transport.put(
        BASE_PATH + "/api/zoom/integration/disconnect",
        {},
      );
      return res.data;
    } catch (error) {
      console.error("Error disconnecting Zoom:", error);
      throw error;
    }
  },

  async fetchHubspotSyncStatus() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/fetch_sync_status`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot sync status:", error);
      throw error;
    }
  },

  async enableHubspotSyncStatus() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/hubspot/enable_sync`);
      return res.data;
    } catch (error) {
      console.error("Error enabling Hubspot sync status:", error);
      throw error;
    }
  },

  async fetchHubspotContactLifeCycleMapping() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/fetch_contact_lifecycle_mapping`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot contact lifecycle mapping:", error);
      throw error;
    }
  },

  async saveHubspotContactLifeCycleMapping(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/hubspot/save_contact_lifecycle_mapping`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Hubspot contact lifecycle mapping:", error);
      throw error;
    }
  },

  async fetchHubspotLifecycleStages() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/contact/lifecycle_stages`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot lifecycle stages:", error);
      throw error;
    }
  },

  async fetchHubspotEntityStatusMapping(entityType) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/fetch_statuses_mappings/${entityType}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot entity status mapping:", error);
      throw error;
    }
  },

  async saveHubspotEntityStatusMapping(entityType, payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/hubspot/save_statuses_mappings/${entityType}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Hubspot entity status mapping:", error);
      throw error;
    }
  },

  async fetchHubspotEntityPropertyMapping(entityType) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/fetch_field_mappings/${entityType}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot entity property mapping:", error);
      throw error;
    }
  },

  async saveHubspotEntityPropertyMapping(entityType, payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/hubspot/save_field_mappings/${entityType}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Hubspot entity property mapping:", error);
      throw error;
    }
  },

  async fetchHubspotEntitySyncDetails(entityType) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/fetch_entity_sync_config/${entityType}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot entity sync details:", error);
      throw error;
    }
  },

  async saveHubspotEntitySyncDetails(entityType, payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/hubspot/save_entity_sync_config/${entityType}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Hubspot entity sync details:", error);
      throw error;
    }
  },

  async fetchHubspotDealPipelines() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/hubspot/deal/pipelines`);
      return res.data;
    } catch (error) {
      console.error("Error fetching Hubspot deal pipelines:", error);
      throw error;
      h;
    }
  },

  async saveHubspotDealPipelines(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/hubspot/deal/save_active_pipelines`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Hubspot deal pipelines:", error);
      throw error;
    }
  },

  async syncPropertiesAgain() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/hubspot/save_entity_fields`,
      );
      return res.data;
    } catch (error) {
      console.error("Error syncing properties again:", error);
      throw error;
    }
  },

  async syncZohoPropertiesAgain() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/zoho/save_entity_fields`);
      return res.data;
    } catch (error) {
      console.error("Error syncing properties again:", error);
      throw error;
    }
  },

  async syncSalesforcePropertiesAgain() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/integration/salesforce/save_entity_fields`,
      );
      return res.data;
    } catch (error) {
      console.error("Error syncing Salesforce properties again:", error);
      throw error;
    }
  },

  async fetchZohoSyncStatus() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/zoho/fetch_sync_status`);
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho sync status:", error);
      throw error;
    }
  },

  async enableZohoSyncStatus() {
    try {
      let res = await transport.post(`${BASE_PATH}/api/zoho/fetch_sync_status`);
      return res.data;
    } catch (error) {
      console.error("Error enabling Zoho sync status:", error);
      throw error;
    }
  },

  async disconnectZoho() {
    try {
      let res = await transport.post(`${BASE_PATH}/api/zoho/disconnect`);
      return res.data;
    } catch (error) {
      console.error("Error disconnecting Zoho:", error);
      throw error;
    }
  },

  // Zoho Entity Methods
  async fetchZohoEntitySyncDetails(entityType) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/zoho/fetch_entity_sync_config/${entityType}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho entity sync details:", error);
      throw error;
    }
  },

  async saveZohoEntitySyncDetails(entityType, payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/zoho/save_entity_sync_config/${entityType}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Zoho entity sync details:", error);
      throw error;
    }
  },

  async fetchZohoEntityPropertyMapping(entityType) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/zoho/fetch_field_mappings/${entityType}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho entity property mapping:", error);
      throw error;
    }
  },

  async saveZohoEntityPropertyMapping(entityType, payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/zoho/save_field_mappings/${entityType}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Zoho entity property mapping:", error);
      throw error;
    }
  },

  async fetchZohoEntityStatusMapping(entityType) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/zoho/entity_status_mapping/${entityType}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho entity status mapping:", error);
      throw error;
    }
  },

  async saveZohoEntityStatusMapping(entityType, payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/zoho/entity_status_mapping/${entityType}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Zoho entity status mapping:", error);
      throw error;
    }
  },

  async fetchZohoStatusMapping() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/zoho/status_mapping`);
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho status mapping:", error);
      throw error;
    }
  },

  async fetchZohoContactLists() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/zoho/contact_lists`);
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho contact lists:", error);
      throw error;
    }
  },

  async fetchZohoActivitiesConfig() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/zoho/activities_config`);
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho activities config:", error);
      throw error;
    }
  },

  async saveZohoActivitiesConfig(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/zoho/save_activities_config`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Zoho activities config:", error);
      throw error;
    }
  },

  async fetchZohoDealPipelines() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/zoho/deal/pipelines`);
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho deal pipelines:", error);
      throw error;
    }
  },

  async saveZohoDealPipelines(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/zoho/deal/save_active_pipelines`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Zoho deal pipelines:", error);
      throw error;
    }
  },

  async fetchZohoLifecycleStages() {
    try {
      let res = await transport.get(`${BASE_PATH}/api/zoho/lifecycle_stages`);
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho lifecycle stages:", error);
      throw error;
    }
  },

  async fetchZohoContactLifeCycleMapping() {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/zoho/contact_lifecycle_mapping`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching Zoho contact lifecycle mapping:", error);
      throw error;
    }
  },

  async saveZohoContactLifeCycleMapping(payload) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/zoho/contact_lifecycle_mapping`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving Zoho contact lifecycle mapping:", error);
      throw error;
    }
  },

  async pullEntityButton(entityType, params) {
    try {
      let res = await transport.post(
        `${BASE_PATH}/api/zoho/pull_entity/${entityType}`,
        params,
      );
      return res.data;
    } catch (error) {
      console.error("Error pulling entity:", error);
      throw error;
    }
  },

  async fetchWhatsAppPhoneNumbers(accessToken) {
    try {
      let res = await marketingTransport.post(
        `/marketing/whatsapp/msg91/phone-numbers`,
        {
          access_token: accessToken,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching WhatsApp phone numbers:", error);
      throw error;
    }
  },

  async createWhatsAppConfig(accessToken, phoneNumbers) {
    try {
      let res = await marketingTransport.post(
        `/marketing/whatsapp/msg91/configs`,
        {
          access_token: accessToken,
          phone_numbers: phoneNumbers,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error creating WhatsApp config:", error);
      throw error;
    }
  },

  async fetchWhatsAppConfigs(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (params.only_connected !== undefined) {
        queryParams.append("only_connected", params.only_connected);
      }

      const queryString = queryParams.toString();
      const url = queryString
        ? `/marketing/whatsapp/configs?${queryString}`
        : `/marketing/whatsapp/configs`;

      let res = await marketingTransport.get(url);
      return res.data;
    } catch (error) {
      console.error("Error fetching WhatsApp configs:", error);
      throw error;
    }
  },

  async updateWhatsAppConfigConnected(id, connected) {
    try {
      let res = await marketingTransport.patch(
        `/marketing/whatsapp/configs/${id}/connected`,
        {
          connected: connected,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error updating WhatsApp config connected status:", error);
      throw error;
    }
  },

  async deleteWhatsAppConfig(id) {
    try {
      let res = await marketingTransport.delete(
        `/marketing/whatsapp/configs/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error deleting WhatsApp config:", error);
      throw error;
    }
  },

  async syncWhatsAppConfig(configId) {
    try {
      let res = await marketingTransport.post(
        `/marketing/whatsapp/templates/configs/${configId}/sync`,
        {},
      );
      return res.data;
    } catch (error) {
      console.error("Error syncing WhatsApp config:", error);
      throw error;
    }
  },

  async fetchWhatsAppTemplates(params) {
    try {
      const queryParams = new URLSearchParams();
      if (params.page !== undefined) {
        queryParams.append("page", params.page);
      }
      if (params.size !== undefined) {
        queryParams.append("size", params.size);
      }
      if (params.search) {
        queryParams.append("search", params.search);
      }
      if (params.status) {
        queryParams.append("status", params.status);
      }
      if (params.config_id) {
        queryParams.append("config_id", params.config_id);
      }

      let res = await marketingTransport.get(
        `/marketing/whatsapp/templates?${queryParams.toString()}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching WhatsApp templates:", error);
      throw error;
    }
  },

  async fetchWhatsAppConfig(configId) {
    try {
      let res = await marketingTransport.get(
        `/marketing/whatsapp/configs/${configId}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching WhatsApp config:", error);
      throw error;
    }
  },

  async uploadWhatsAppMedia(file) {
    try {
      const formData = new FormData();
      formData.append("file", file);

      let res = await marketingTransport.post(
        `/marketing/uploads`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error uploading WhatsApp media:", error);
      throw error;
    }
  },

  async createWhatsappTemplate(payload) {
    try {
      let res = await marketingTransport.post(
        `/marketing/whatsapp/templates`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error creating WhatsApp template:", error);
      throw error;
    }
  },

  async updateWhatsappTemplate(payload) {
    try {
      const templateId = payload.template_id;
      let res = await marketingTransport.put(
        `/marketing/whatsapp/templates/${templateId}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error updating WhatsApp template:", error);
      throw error;
    }
  },

  async getWhatsappTemplateById(templateId) {
    try {
      let res = await marketingTransport.get(
        `/marketing/whatsapp/templates/${templateId}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching WhatsApp template:", error);
      throw error;
    }
  },

  async deleteWhatsappTemplate(templateId, configId) {
    try {
      let res = await marketingTransport.delete(
        `/marketing/whatsapp/templates/${templateId}?config_id=${configId}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error deleting WhatsApp template:", error);
      throw error;
    }
  },

  async cloneWhatsappTemplate(templateId, configId) {
    try {
      let res = await marketingTransport.post(
        `/marketing/whatsapp/templates/${templateId}/clone`,
        { config_id: configId },
      );
      return res.data;
    } catch (error) {
      console.error("Error cloning WhatsApp template:", error);
      throw error;
    }
  },
};
